module.exports = __webpack_public_path__ + "img/abc.05a096d1.svg";